import { Box, Card, useMediaQuery, useTheme } from "@mui/material";
import React from "react";

import * as Styles from "pages/requests/stepsIndividual/step2/step2.styles";
import Content from "./step4.content";

interface Props {
  title: string;
  onBackClick: () => void;
  showMessage: MessageBox;
}

const Step4 = ({ title, onBackClick, showMessage }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.between("xs", "lg"));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        mt: "50px",
      }}
    >
      {isMobile ? (
        <Content
          title={title}
          onBackClick={onBackClick}
          showMessage={showMessage}
        />
      ) : (
        <Card sx={Styles.cardCSS(theme)}>
          <Content
            title={title}
            onBackClick={onBackClick}
            showMessage={showMessage}
          />
        </Card>
      )}
    </Box>
  );
};

export default Step4;
